import styles from './MuseeFabreHeader.module.css'

import { SvgOfficialLogoMuseeFabre } from '../../../svg/SvgComponents'

const MuseeFabreHeader = () => (
  <header className={styles.header}>
    <div className={styles.logo}>
      <SvgOfficialLogoMuseeFabre />
    </div>
  </header>
)

export default MuseeFabreHeader
